import React from 'react'
import RequestUpdatePage from "./RequestUpdatePage"

function RequestUpdateContainer(props) {
    return (
        <div className="RequestUpdateContainer">
            <RequestUpdatePage/>
        </div>
    )
}

export default RequestUpdateContainer